// This file is auto-generated by ./bin/rails stimulus:manifests:update_all
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChoicesController from "./choices_controller"
application.register("choices", ChoicesController)

import InputCharacterCounterController from "./input_character_counter_controller"
application.register("input-character-counter", InputCharacterCounterController)

import LazyLoadController from "./lazy_load_controller"
application.register("lazy-load", LazyLoadController)

import PreserveFocusController from "./preserve_focus_controller"
application.register("preserve-focus", PreserveFocusController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TocNavigationController from "./toc_navigation_controller"
application.register("toc-navigation", TocNavigationController)
